import React from 'react';
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";

type FixedFilterComponent = () => JSX.Element;

export const DirectLinkList = styled.ul`
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    display: inline;
    margin-right: 37px;

    &:first-child {
      margin-left: 23px;

      @media (min-width: 1024px) {
        margin-left: 30px;
      }
    }
  }
`;

export const DirectLinkWrapper = styled.div`
  padding-bottom: 2rem;
`;

export const DirectLinkDivider = styled.div`
  color: ${colors.white.base};
  font-family: "Helvetica Now Micro W01 Medium", sans-serif;
  font-size: 13px;
  letter-spacing: -0.02em;
  margin: 0 0 1.333rem 1.333rem;
  display: flex;
  align-items: center;
  &:after {
    content: '';
    margin: 1px 0.5rem 0 0.5rem;
    display: inline;
    width: 100%;
    height: 1px;
    background-color: ${colors.white.base}
  }
  @media (min-width: 1024px) {
    margin-left: 30px;
  }
`;

export const DirectLink = styled.a`
  font-family: 'Helvetica Now Text W01 Regular', sans-serif;
  font-size: 14px;
  color: ${colors.slate["20"]};
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

const FixedFilter: FixedFilterComponent = () => {

  return (
    <DirectLinkWrapper>
      <DirectLinkDivider>
        Oder
      </DirectLinkDivider>
      <DirectLinkList>
        <li>
          <DirectLink href={'https://sopm-w2p.faros.ch/'} target={'_blank'}>Privatanzeigen</DirectLink>
        </li>
        <li>
          <DirectLink href={'https://abschied-nehmen.ch/'} target={'_blank'}>Traueranzeigen</DirectLink>
        </li>
      </DirectLinkList>
    </DirectLinkWrapper>
  )
}

export default FixedFilter;
